<!--
 * @FileDescription: 已出账的账单详情
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="账单信息" :visible.sync="visible" width="1024px" :before-close="close">
    <div class="top">
      <p>
        <span>
          <span class="label">账单号: </span>
          <span class="value">{{ defaultTips(info.billId) }}</span>
        </span>
      </p>
      <p>
        <span>
          <span class="label">应收款: </span>
          <span class="value">{{ amount(info.amount) }}</span>
        </span>
        <span class="paid">
          <span class="label">已付款: </span>
          <span class="value">{{ paidAmount(info.paidAmount) }}</span>
        </span>
      </p>
    </div>

    <el-table v-loading="loading" :data="bills" size="medium" border row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}px`">
      <el-table-column prop="kkOrderId" label="订单号">
        <template v-slot="{ row }">
          {{ defaultTips(row.kkOrderId) }}
        </template>
      </el-table-column>
      <el-table-column prop="packId" label="包裹号">
        <template v-slot="{ row }">
          {{ defaultTips(row.packId) }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="应收款">
        <template v-slot="{ row }">
          {{ amount(row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="发货时间">
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.deliveryDate)) }}
        </template>
      </el-table-column>
      <el-table-column prop="fulfillmentStatus" label="包裹状态">
        <template v-slot="{ row }">
          {{ fulfillmentStatus(row.fulfillmentStatus) }}
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" @click="save">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'

export default {
  data() {
    return {
      visible: false,

      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 380,

      loading: false,
      info: {
        billId: undefined, // 账单号
        amount: undefined, // 应收款
        paidAmount: undefined // 已付款
      },
      bills: [],
      total: 0
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `+US$${value}` : '-'
      }
    },
    paidAmount() {
      return (value) => {
        return value ? `+US$${value}` : '-'
      }
    },
    fulfillmentStatus() {
      return (value) => {
        switch (value) {
          case 'waiting_to_ship':
            return '待发货'
          case 'shipped':
            return '已发货'
          case 'partial_shipped':
            return '部分发货'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 根据账单ID获取账单详情
     *
     * @param {String} billId 账单ID
     */
    async getBillDetailsById(billId) {
      try {
        this.loading = true
        let { data } = await API.getBillDetailsById(billId)
        this.bills = data.list
        this.total = data.total
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    show(payload) {
      this.visible = true
      this.info.billId = payload.billId
      this.info.amount = payload.amount
      this.info.paidAmount = payload.paidAmount
      this.getBillDetailsById(payload.billId)
    },

    save() {
      this.close()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.info = {
        billId: undefined,
        amount: undefined,
        paidAmount: undefined
      }
      this.bills = []
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  margin-bottom: 15px;
  p {
    &:nth-child(1) {
      margin-bottom: 12px;
    }
    .label {
      font-weight: 600;
    }
    .paid {
      display: inline-block;
      margin-left: 128px;
      .value {
        color: #99c41c;
      }
    }
  }
}
</style>
